<template>
    <form @submit.prevent="submit()">
        <modal width="small">
            <modal-header>
                Kommentare für Vorgang
            </modal-header>
            <modal-content>
                <table class="table table--stripped">
                    <thead>
                    <tr>
                        <th>Kommentar</th>
                        <th>Datum</th>
                        <th>Operator</th>
                    </tr>
                    </thead>
                    <tbody v-if="!noComments">
                    <tr v-for="comment in commentsTable" :key="comment.id">
                        <td>{{ comment.comment }}</td>
                        <td>{{ this.$dateTime(comment.created_at) }}</td>
                        <td>{{ comment.admin_user.name }}</td>
                    </tr>
                    </tbody>
                    <tbody v-if="noComments">
                    <tr>
                        <td colspan="3" class="text-center"><strong>keine Kommentare vorhanden</strong></td>
                    </tr>
                    </tbody>
                </table>
            </modal-content>
            <modal-content>
                <form-text id="comment" v-model="form.comment" label="Kommentar" :error="form.errors.comment"/>
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Speichern</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import FormText from '@partfactory/Shared/Form/FormText';
import {useForm} from '@inertiajs/vue3';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';

export default {
    name: 'AskForQuoteComment',
    components: {FormButton, ModalActions, FormText, ModalContent, ModalHeader, Modal},
    props: {
        askForQuote: Object,
    },
    setup() {
        const form = useForm({
            comment: null,
        });

        return {form};
    },
    computed: {
        commentsTable() {
            return this.askForQuote.ask_for_quote_comments;
        },
        noComments() {
            return this.askForQuote.ask_for_quote_comments.length === 0;
        },
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.comments.post', {'askForQuote': this.askForQuote}), {
                    onSuccess: () => this.form.reset('comment'),
                });
        }
    }
};
</script>
